import React, { memo, useEffect, useState } from "react";
import { Button, Col, Menu, Modal, Row, Space, Table } from "antd";
import PropTypes from "prop-types";
import Icon, { CloseOutlined, LogoutOutlined, ProfileOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import Styles from "./Styles";
import { ReactComponent as LogoutIcon } from "../../../assets/images/logout_icon.svg";
import { adminMenuData, adminPlatformMenuData, customerMenuData, deviceMenuData, normalUserMenuData } from "./../../../menuData";
import ImgNew from "../../../assets/images/icon_notification_16.svg";
import { getGlobalSessionParam, isEmpty } from "../../../utils/comm";
import { apiGet, apiGetDeviceError, apiGetEventRead, apiGetMasterCode, apiGetSitesComp } from "../../../api/api";
import { Auth } from "aws-amplify";
import Layout, { Content, Footer, Header } from "antd/lib/layout/layout";

const { SubMenu } = Menu;

function Sider({ isSiderOpen, setSiderOpen }) {
  const [isAdmin, setIsAdmin] = useState(0); // 0: 회사관리자, 1:사업장관리자, 2:디바이스관리자, 3:플랫폼관리자, 4:일반사용자
  let menuData =
    (isAdmin === 0 && adminMenuData) ||
    (isAdmin === 1 && customerMenuData) ||
    (isAdmin === 2 && deviceMenuData) ||
    (isAdmin === 3 && adminPlatformMenuData)||
    (isAdmin === 4 && normalUserMenuData);
  const [eventCount, setEventCount] = useState(0);
  const [deviceCount, setDeviceCount] = useState(0);
  const [userInfo, setUserInfo] = useState({ currentAuthCdNm: "", currentSiteNm: "" });
  let navigate = useNavigate();
  let menuCnt = 0;

  useEffect(() => {
    // 세션이 비어있을 경우 로그인 화면으로 이동
    if (isEmpty(sessionStorage.getItem("userId"))) {
      window.location.replace("/");
      return;
    }

    // 권한별 메뉴 이동
    switch (sessionStorage.getItem("authCd")) {
      case "AUC00010": // 회사 관리자
        setIsAdmin(0);
        menuData = adminMenuData;
        break;
      case "AUC00020": // 사업장 관리자
        setIsAdmin(1);
        menuData = customerMenuData;
        break;
      case "AUC00030": // 디바이스 관리자
        setIsAdmin(2);
        menuData = deviceMenuData;
        break;
      case "AUC00090": // 플랫폼 관리자
        setIsAdmin(3);
        menuData = adminPlatformMenuData;
        break;
      case "AUC00040": // 일반사용자
        setIsAdmin(4);
        menuData = normalUserMenuData;
        break;
    }

    menuData.map((item) => {
      let url = window.location.pathname.replace("/", "");

      if (isEmpty(item.subMenu)) {
        if (url == item.key) {
          menuCnt++;
          return;
        }
      }

      if (!isEmpty(item.subMenu)) {
        item.subMenu.map((item) => {
          if (url == item.key) {
            menuCnt++;
            return;
          }
        });
      }
    });

    if (menuCnt < 1) {
      window.history.back();
    }

    apiGetEventReadCall().then();
    apiGetDeviceErrorCall().then();
    setInterval(() => {
      apiGetEventReadCall().then();
      apiGetDeviceErrorCall().then();
    }, 1000 * 10);
  }, []);

  // 메뉴 변경 토글 (관리자/고객)
  const onMenuChange = () => {
    setIsAdmin(0);
  };
  const onClickCloseBtn = () => {
    setSiderOpen(false);
  };

  const onClickMenu = ({ domEvent }) => {
    sessionStorage.setItem("tabTitle", domEvent.target.innerText);
    setSiderOpen(false);
  };

  // 이벤트 갯수 조회
  const apiGetEventReadCall = async () => {
    const siteId = getGlobalSessionParam("siteId");
    const svcCd = getGlobalSessionParam("svcCd");

    if (!isEmpty(String(siteId)) && !isEmpty(svcCd)) {
      const model = {
        siteId: siteId,
        svcCd: svcCd,
      };

      try {
        const response = await apiGetEventRead(model);
        if (response.data.code === 0) {
          setEventCount(response.data.data.readYn);
        }
      } catch (e) {
        setEventCount(0);
      }
    } else {
      setEventCount(0);
    }
  };

  // 디바이스 오류 갯수 조회
  const apiGetDeviceErrorCall = async () => {
    const model = {
      siteId: sessionStorage.getItem("siteId"),
    };

    try {
      const response = await apiGetDeviceError(model);
      if (response.data.code === 0) {
        setDeviceCount(response.data.data.errCount);
      }
    } catch (e) {}
  };

  const logoutConfirm = () => {
    Modal.confirm({
      title: "로그아웃",
      icon: null,
      content: "정말로 로그아웃 하시겠습니까?",
      okText: "로그아웃",
      cancelText: "취소",
      centered: true,
      onOk: async () => {
        await Auth.signOut();
        window.location.href = "/";
        sessionStorage.clear();
        localStorage.clear();
      },
    });
  };

  return (
    <Styles theme='dark' width='240' className={isSiderOpen ? "sider-open" : ""}>
      <Layout style={{ height: "100%" }}>
        <Header style={{ width: "100%", height: "max-content", padding: "0", backgroundColor: "transparent" }}>
          <div className='logo'>
            InteleSafety
            <Button className='btn-menu-close' icon={<CloseOutlined />} onClick={onClickCloseBtn} />
          </div>
        </Header>
        <Content style={{ width: "100%", padding: "0", backgroundColor: "transparent" }}>
          <Menu
            mode='inline'
            defaultOpenKeys={["sub-0", "sub-1", "sub-2"]}
            theme='dark'
            overflowedIndicator={<ProfileOutlined />}
            onClick={onClickMenu}
            defaultSelectedKeys={window.location.pathname.replace("/", "")}
            selectedKeys={window.location.pathname.replace("/", "")}
          >
            {menuData &&
              menuData.map((item, index) => {
                return item.link ? (
                  <Menu.Item key={item.key} icon={item.icon}>
                    <Link to={item.link}>
                      {/* {item.icon && <img src={item.icon} alt="" className="menu-icon" />} */}
                      {item.title}
                    </Link>
                  </Menu.Item>
                ) : (
                  item.subMenu && (
                    <SubMenu key={`sub-${index}`} title={item.title}>
                      {item.subMenu.map((item, index2) => {
                        return (
                          <Menu.Item key={item.key} icon={item.icon}>
                            <Link to={item.link}>
                              {item.title}
                              {item.key == "manageDevice" && deviceCount > 0 ? (
                                <span className='alarm'>{deviceCount}</span>
                              ) : (
                                ""
                              )}
                              {item.key == "manageEvents" && eventCount > 0 ? (
                                <img src={ImgNew} alt='new' className='ico-new' />
                              ) : (
                                ""
                              )}
                            </Link>
                          </Menu.Item>
                        );
                      })}
                    </SubMenu>
                  )
                );
              })}
          </Menu>
        </Content>
        <Footer style={{ width: "100%", padding: "0", marginBottom: "30px", backgroundColor: "transparent" }}>
          <div
            className={"user-info-zone"}
            style={{ backgroundColor: "#292C33", width: "100%", padding: "14px 24px" }}
          >
            <div style={{ marginBottom: "7px", fontSize: "15px", fontWeight: "700", color: "#BAC0CC" }}>
              {sessionStorage.getItem("userName")}
            </div>
            <div style={{ fontSize: "14px", fontWeight: "400", color: "#AAB1BF" }}>
              <Row>
                <Col span={8}>사업장</Col>
                <Col span={16}>
                  {!isEmpty(sessionStorage.getItem("siteNm")) ? sessionStorage.getItem("siteNm") : "-"}
                </Col>
              </Row>
              <Row>
                <Col span={8}>담당</Col>
                <Col span={16}>
                  {!isEmpty(sessionStorage.getItem("authNm")) ? sessionStorage.getItem("authNm") : "-"}
                </Col>
              </Row>
            </div>
          </div>

          <Menu
            mode='inline'
            defaultOpenKeys={["sub-0", "sub-1", "sub-2"]}
            theme='dark'
            overflowedIndicator={<ProfileOutlined />}
            onClick={onClickMenu}
            defaultSelectedKeys={window.location.pathname.replace("/", "")}
            selectedKeys={window.location.pathname.replace("/", "")}
          >
            <Menu.Item key={"logout"} icon={<Icon component={LogoutIcon} />}>
              <Link to={"#"} onClick={logoutConfirm}>
                <span>로그아웃</span>
              </Link>
            </Menu.Item>
          </Menu>
        </Footer>
      </Layout>
    </Styles>
  );
}

Sider.propTypes = {
  isSiderOpen: PropTypes.bool.isRequired,
  setSiderOpen: PropTypes.func.isRequired,
};

export default memo(Sider);
